import AboutUsInfo from '../components/AboutUsInfo';

function About() {
  return (
    <>
      <AboutUsInfo />
    </>
  );
}

export default About;
